import {useEffect, useMemo, useState} from "react";
import {useNavigate} from "react-router";

export function useRouter() {
    const navigate = useNavigate();

    const router = useMemo(
        () => ({
            back: () => navigate(-1),
            forward: () => navigate(1),
            reload: () => window.location.reload(),
            push: (href: string) => navigate(href),
            replace: (href: string) => navigate(href, {replace: true}),
        }),
        [navigate],
    );

    return router;
}


// 函数要以use开头
export function useWindowSize() {
    const getWindowSize = () => ({
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth,
    });

    const [windowSize, setWindowSize] = useState(getWindowSize());

    const handleResize = () => {
        setWindowSize(getWindowSize());
    };

    useEffect(() => {
        // 监听
        window.addEventListener('resize', handleResize);

        // 销毁
        return () => window.removeEventListener('resize', handleResize)
    }, []);

    return windowSize;
}
